import PropTypes from "prop-types";

export default PropTypes.shape({
  fileName: PropTypes.string,
  percentComplete: PropTypes.number,
  timeLeft: PropTypes.string,
});
